import { ClickStatistics } from './click-statistics.model';

export class SentMessageStatistics {
  public SendSuccessCount: number = 0;
  public SendFailCount: number = 0;
  public UniqueReadCount: number = 0;
  public MessageClickUniqueCount: number = 0;
  public ReadTotal: number = 0;
  public TotalSent: number = 0;
  public Total: number = 0;
  public FirstRead: Date = new Date();
  public LastRead: Date = new Date();
  public Clicks: ClickStatistics[] = [];
}
